import { z } from 'zod';

export const StandardAnalyticEventSchema = z.object({
  id: z.string().uuid(),
  created: z.string().date(),
  updated: z.string().date(),
  name: z.string(),
  description: z.string(),
  categoryId: z.string().uuid(),
  customAttributeKeys: z.array(z.string()),
  categoryName: z.string().optional(),
});

export type StandardAnalyticEvent = z.infer<typeof StandardAnalyticEventSchema>;

export interface StandardAnalyticEventFindAllParams {
  q?: string;
  limit?: number;
  offset?: number;
  orderBy?: string;
  orderDirection?: 'asc' | 'desc';
  categoryId?: string;
}
